import type { ProjectStatus } from "@energyos/shared-types";

const LABELS: Record<ProjectStatus, string> = {
  draft: "Entwurf",
  geo_analysis: "Geoanalyse",
  planning: "Planung",
  simulation: "Simulation",
  technical_review: "Technische Prüfung",
  economic_review: "Wirtschaftlichkeitsprüfung",
  ready_for_offer: "Angebotsreif",
  sent_to_servicehub: "An ServiceHub übergeben",
  offered: "Angebot erstellt",
  accepted: "Angenommen",
  in_execution: "In Ausführung",
  commissioned: "In Betrieb",
  monitoring: "Monitoring",
  archived: "Archiviert",
};

// §22: „Nicht nur Farbe verwenden. Immer zusätzlich Symbol + Text." — Glyph je Status,
// damit der Status auch ohne Farbe (Barrierefreiheit/Druck) erkennbar ist.
const SYMBOL: Record<ProjectStatus, string> = {
  draft: "✎",
  geo_analysis: "◐",
  planning: "◐",
  simulation: "◐",
  technical_review: "⚑",
  economic_review: "⚑",
  ready_for_offer: "▲",
  sent_to_servicehub: "▲",
  offered: "▲",
  accepted: "●",
  in_execution: "●",
  commissioned: "✓",
  monitoring: "✓",
  archived: "◼",
};

const CSS: Record<ProjectStatus, string> = {
  draft: "badge-draft",
  geo_analysis: "badge-planning",
  planning: "badge-planning",
  simulation: "badge-simulation",
  technical_review: "badge-review",
  economic_review: "badge-review",
  ready_for_offer: "badge-offer",
  sent_to_servicehub: "badge-offer",
  offered: "badge-offer",
  accepted: "badge-active",
  in_execution: "badge-active",
  commissioned: "badge-active",
  monitoring: "badge-active",
  archived: "badge-archived",
};

export function StatusBadge({ status }: { status: string }) {
  const s = status as ProjectStatus;
  return (
    <span className={`badge ${CSS[s] ?? "badge-draft"}`}>
      <span aria-hidden="true" style={{ marginRight: 4 }}>{SYMBOL[s] ?? "○"}</span>
      {LABELS[s] ?? status}
    </span>
  );
}
